// Sticky footer summarizing save state. The Continue control now lives on the
// BriefPulse card so the editor sees it alongside the gating questions.
export default function BriefFooter({
  articleCount,
  saving,
  savedAt,
  saveError,
  onSaveNow,
}) {
  return (
    <div className="sticky bottom-0 z-30 -mx-4 sm:-mx-6 mt-8 px-4 sm:px-6 py-3 bg-black/95 backdrop-blur border-t border-[#333] flex flex-wrap items-center gap-3">
      <div className="font-display text-[11px] font-bold tracking-display-md uppercase text-hxd-muted">
        {articleCount} article{articleCount === 1 ? '' : 's'}
      </div>

      <div className="ml-auto flex items-center gap-3 flex-shrink-0">
        {saveError ? (
          <span className="text-hxd-err text-[12px] max-w-[260px] truncate">{saveError}</span>
        ) : saving ? (
          <span className="text-hxd-orange-bright text-[12px]">Saving…</span>
        ) : savedAt ? (
          <span className="text-hxd-ok text-[12px]">
            Saved {savedAt.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
          </span>
        ) : (
          <span className="text-hxd-muted text-[12px]">No unsaved changes</span>
        )}
        <button
          type="button"
          onClick={onSaveNow}
          disabled={saving}
          className="hxd-btn hxd-btn-ghost hxd-btn-sm border-hxd-muted text-white"
        >
          Save now
        </button>
      </div>
    </div>
  );
}
